import { useMutation } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";

import { IMetaAdsSaveAccountRequest } from "../../features/Campaigns/interface/metaAds";

export const useMetaAdsSaveAccount = () => {
    return useMutation<any, Error, IMetaAdsSaveAccountRequest>({
        mutationFn: (data) => httpService.post<any, IMetaAdsSaveAccountRequest>(API_CONFIG.path.metaAdsSaveAccount, data),
    });
};
